import React from 'react';
import {Link} from 'react-router-dom';
import moment from 'moment';
import Avatar from '../../components/Avatar';
import Icon from '../../components/Icon';

const ForumItem = ({item}) => {
  return (
    <Link to={`/forums/${item.id}`} className="list-group-item list-group-item-action py-3">
      <div className="row gx-0">
        <div className="col-auto">
          <Avatar user={item.user} size={60} />
        </div>
        <div className="col ms-3">
          <div className="row gx-2 align-items-center">
            <div className="col-auto fw-bold">{item.user.fullname}</div>
            <div className="col-auto font-2 text-muted">{moment(item.createdAt).format('DD MMM YYYY')}</div>
            {item.closed && (
              <div className="col-auto ms-auto">
                <Icon name="check" size={16} color="success" />
              </div>
            )}
          </div>
          <div className="mb-1">{item.name}</div>
          <div className="row mb-1">
            <div className="col">
              <div className="row gx-2 font-2">
                {item.tags.map(tag => (
                  <div key={tag.id} className="col-auto">
                    <div className="badge bg-warning">{tag.lesson.name}</div>
                  </div>
                ))}
              </div>
            </div>
            <div className="col-auto">
              <div className="row align-items-center font-2 gx-1 text-muted">
                <div className="col-auto">
                  <Icon name="eye" />
                </div>
                <div className="col-auto">{item.viewsCount}</div>
                <div className="col-auto ms-2">
                  <Icon name="comment" />
                </div>
                <div className="col-auto">{item.commentsCount}</div>
                <div className="col-auto ms-2">
                  <Icon name="thumbs-up" />
                </div>
                <div className="col-auto">{item.likesCount}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default ForumItem;
